export default __webpack_public_path__ + "static/media/desktop-etapa3.f396ec73.jpg";